export const medicalImg: { [key: string]: string } = {
    "feguia": "images/Eguia.png",
    "jcerda": "images/Cerda.png",
    "lrivera": "images/LRivera.png",
    "mbarraza": "images/Barraza.png",
    "MtArronte": "images/Arronte.png",
    "nrivera": "images/NRivera.png",
    "ogatica": "images/OGatica.png",
    "rcastillo": "images/Castillo.png",
    "Roxana Aceedo": "images/Acevedo.png",
    "ccarcamo": "images/md-del-usuario.png",
    "cgreene": "images/md-del-usuario.png",
    "maguirre": "images/md-del-usuario.png",
    "oburgos": "images/md-del-usuario.png",
}
